import { Component } from 'react'
import { BrowserRouter as Router,  Route, Switch } from 'react-router-dom'
import { Header } from "./components/Header"
import { Home } from "./pages/Home"

class App extends Component {
  render() {
    return (
      <div className="App" style={{ "minHeight": "calc(100vh - 250px - 56px - 54px)" }} >
        <Router>
          <Header />
          <main className="container">
            <Switch>
              <Route exact path="*" component={Home} />
            </Switch>
          </main>
        </Router>
      </div>
    )
  }
}

export default App;